// extracted by mini-css-extract-plugin
export default {"highligthed":"ResultSection_highligthed__Cs-2w","details":"ResultSection_details__xcCln styles_space__4PdT-"};